import React, { Component } from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import PropTypes from 'prop-types';
import { Table } from "reactstrap";
import { NavLink } from 'react-router-dom';

import { ROUTES, insertIdtoUrl } from 'constants/Routes';
import { getUserId } from "constants/localStorageManager.js";

class BusinessUsersList extends Component {
  render() {
    const {
      users, deleteUser, invitedUsers, resendUserInvitation, deleteUserInvitation
    } = this.props;
    const $userList = users.map(user => {
      let currentUser = getUserId() == user.user.id;
      return (
        <tr key={user.user.id}>
          <td>
            <NavLink to={insertIdtoUrl(ROUTES.USER_SHOW, user.user.id)}>
              <span
                data-toggle="tooltip"
                data-placement="bottom"
                title={`${currentUser ? "Your Account" : ""}`}
              >
                {user.user.first_name} {user.user.middle_name}{" "}
                {user.user.last_name}
                {currentUser ? "*" : ""}
              </span>
            </NavLink>
          </td>
          <td>{user.user.email}</td>
          <td>{user.user.role}</td>
          <td>Active</td>
          <td>
            {currentUser ? (
              ""
            ) : (
                <span
                  className="circular-icon icon-cross"
                  onClick={deleteUser.bind(this, user.id)}
                >
                  <FontAwesomeIcon icon="trash-alt" />
                </span>
              )}
          </td>
        </tr>
      );
    });
    const $invitedUsers = invitedUsers.map(user => {
      return (
        <tr>
          <td />
          <td>{user.email}</td>
          <td>business_{user.role}</td>
          <td>Pending Confirmation</td>
          <td>
            <span
              className="circular-icon icon-check"
              onClick={resendUserInvitation.bind(this, user.id)}
              data-toggle="tooltip"
              data-placement="bottom"
              title="Resend invitation"
            >
              <FontAwesomeIcon icon="envelope" />
            </span>
            <span
              className="circular-icon icon-cross"
              onClick={deleteUserInvitation.bind(this, user.id)}
            >
              <FontAwesomeIcon icon="trash-alt" />
            </span>
          </td>
        </tr>
      );
    });
    return (
      <div>
        <Table hover className="styled-box-shadow" responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th className="action-head-120">Action</th>
            </tr>
          </thead>
          <tbody>
            {$userList}
            {$invitedUsers}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default BusinessUsersList;

BusinessUsersList.propTypes = {
  users: PropTypes.array,
  deleteUser: PropTypes.func,
  invitedUsers: PropTypes.array,
  resendUserInvitation: PropTypes.func,
  deleteUserInvitation: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/BusinessUsersList.js